<template>
  <div class="container">
    <!-- Modal -->
    <div class="modal fade modal-evidencia" id="modalHistoricoSla" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">

          <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
              <h1 class="modal-title">Histórico de evidências</h1>
          </div>
          <div class="modal-body alert-body">

            <div class="filtro-historico-sla">
              <b-form-group
                label="Filtrar pesquisa"
                label-for="filterInput"
                align="center"
              >
                <b-input-group>
                  <b-form-input
                    v-model="filter"
                    type="search"
                    style="margin: 10px;text-align: center;"
                    placeholder="Pesquise por qualquer palavra chave"
                  >
                  </b-form-input>
                      <b-button :disabled="!filter" @click="filter = ''" class="limparPesquisaBotao" variant="primary">Limpar pesquisa</b-button>
                </b-input-group>
              </b-form-group>
            </div>
            <b-table 
                class = "teste"
                striped hover
                :items="this.$store.state.historicoSla.historicoSla"
                :filter="filter">
              </b-table>
          </div> 
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Fechar</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      filter: null,
      filterOn: []
    }
  }
}
</script>
<style scoped>
.modal-header {
    background-color: #3b8dbc;
    text-align: center;
    color: #FFFF;
  }
#filterInput{
  margin: 10px;
  text-align: center;
}
.filtro-historico-sla{
  background-color: rgba(222, 223, 240, 0.726);
  margin: -14px;
  position: sticky;
  top: 0;
}
.modal-dialog{
  width: 60%;
}
.limparPesquisaBotao{
  margin-bottom: 5%;
}

</style>




// WEBPACK FOOTER //
// ModalHistoricoSla.vue?675adeec